/**
 * List Schema of Motorista
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'

/* TODO: review generated schema */
export class ListMotoristaSchema extends Schema {
  readonly name = 'ListMotorista'

  readonly fieldSet: FieldSet<Motorista> = {
    idMotoristaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
      bind: {
        class: 'uppercase',
      },
    }),
    cpf: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.cpf(schema.model.cpf),
      },
    }),
    celular: (): FieldComponent => ({
      is: Component.Render,
    }),
    versao: (): FieldComponent => ({
      is: Component.Render,
    }),
    marcaAparelho: (): FieldComponent => ({
      is: Component.Render,
    }),
    modeloAparelho: (): FieldComponent => ({
      is: Component.Render,
    }),
    placaVeiculo: (): FieldComponent => ({
      is: Component.Render,
      bind: {
        class: 'uppercase',
      },
    }),
    nomeCriador: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.nomeCriador,
      },
    }),
  }
}
